import {Injectable} from '@angular/core';
import {BaseApiEndpointService} from '../base-endpoint/base-endpoint.service';
import {ListItem} from '../../types/list-item.type';
import {ServiceProviderHub} from '@generated-backend-types';
import ServiceProviderBudget =
  ServiceProviderHub.App.Http.Resources.ServiceProviderHub.Resources.ServiceProviderBudgets.ServiceProviderBudget;

@Injectable({providedIn: 'root'})
export class ServiceProviderBudgetsService extends BaseApiEndpointService<ServiceProviderBudget> {
  protected override endpoint = '/service-provider-budgets';

  public modelToMultiSelectItem(m: ServiceProviderBudget): ListItem & {model: ServiceProviderBudget} {
    return {id: m.id, text: m.ext_budget_id, isDisabled: false, model: m};
  }
}
